(function () {
  'use strict';

  function formatBRL(cents) {
    var value = cents / 100;
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function initKit(root) {
    if (root.dataset.benduInitialized === 'true') return;
    root.dataset.benduInitialized = 'true';

    var scope = root.closest('.wt-product') || document;

    var kitQuantity = parseInt(root.dataset.kitQuantity, 10) || 3;
    var discountPct = parseFloat(root.dataset.kitDiscountPct) || 10;
    var discountFactor = 1 - discountPct / 100;
    var basePrice = parseInt(root.dataset.basePrice, 10) || 0;
    var baseCompare = parseInt(root.dataset.baseCompare, 10) || 0;
    var singleMax = 2;

    var qtyButtons = root.querySelectorAll('[data-bendu-qty]');
    var flavorButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-bendu-flavor]')
    );

    var counterEl = root.querySelector('[data-bendu-counter]');
    var hintEl = root.querySelector('[data-bendu-hint]');
    var titleEl = root.querySelector('[data-bendu-flavor-title]');
    var perUnitEl = root.querySelector('[data-bendu-per-unit]');
    var perUnitPriceEl = root.querySelector('[data-bendu-per-unit-price]');
    var ctaBtn = root.querySelector('[data-bendu-cta]');
    var ctaText = root.querySelector('[data-bendu-cta-text]');

    var state = {
      mode: 1,
      limit: 1,
      order: [],
      selections: {},
    };

    function totalSelected() {
      var total = 0;

      for (var k in state.selections) {
        total += state.selections[k].qty;
      }

      return total;
    }

    function addOne(variantId, data) {
      var current = state.selections[variantId];

      if (!current) {
        state.selections[variantId] = {
          qty: 1,
          price: data.price,
          stock: data.stock,
          tracked: data.tracked,
          policy: data.policy,
          name: data.name,
        };

        state.order.push(variantId);
      } else {
        current.qty += 1;
      }
    }

    function removeOne(variantId) {
      var current = state.selections[variantId];

      if (!current) return;

      current.qty -= 1;

      if (current.qty <= 0) {
        delete state.selections[variantId];

        var idx = state.order.indexOf(variantId);
        if (idx >= 0) {
          state.order.splice(idx, 1);
        }
      }
    }

    function getFlavorData(btn) {
      return {
        price: parseInt(btn.dataset.variantPrice, 10),
        stock: parseInt(btn.dataset.variantStock, 10),
        tracked: btn.dataset.variantTracked === 'true',
        policy: btn.dataset.variantPolicy || 'deny',
        name: btn.dataset.flavorTitle,
      };
    }

    function canAddByStock(btn) {
      var variantId = btn.dataset.variantId;
      var data = getFlavorData(btn);
      var current = state.selections[variantId];
      var currentQty = current ? current.qty : 0;

      if (
        data.tracked &&
        data.policy === 'deny' &&
        currentQty + 1 > data.stock
      ) {
        return false;
      }

      return true;
    }

    function tryAdd(btn) {
      if (
        btn.classList.contains('is-unavailable') ||
        btn.disabled ||
        !canAddByStock(btn)
      ) {
        return false;
      }

      var variantId = btn.dataset.variantId;
      var data = getFlavorData(btn);

      if (state.mode === 1 && totalSelected() >= singleMax) {
        setQtyMode(kitQuantity);
      }

      addOne(variantId, data);
      return true;
    }

    function setQtyMode(mode) {
      state.mode = mode;
      state.limit = mode;

      qtyButtons.forEach(function (btn) {
        var btnMode = parseInt(btn.dataset.benduQty, 10);
        btn.classList.toggle('is-active', btnMode === mode);
      });

      if (perUnitEl) {
        perUnitEl.hidden = mode !== kitQuantity;
      }

      if (mode === 1) {
        while (totalSelected() > singleMax) {
          var lastId = state.order[state.order.length - 1];

          if (!lastId) break;

          removeOne(lastId);
        }
      }

      if (titleEl) {
        titleEl.textContent = 'Escolha seus sabores:';
      }

      if (hintEl) {
        hintEl.textContent =
          mode === 1
            ? 'Clique no produto ou use + e − para selecionar. Use "Ver produto" para abrir a página.'
            : 'Monte seu kit com + e −. Use "Ver produto" para abrir a página.';
      }

      render();
    }

    function getProductUrl(btn) {
      if (btn.dataset.productUrl) {
        return btn.dataset.productUrl;
      }

      var handle = btn.dataset.flavorHandle;
      if (!handle) return '';

      var rootPath =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      return (
        rootPath.replace(/\/?$/, '/') +
        'products/' +
        encodeURIComponent(handle)
      );
    }

    function openFlavorProduct(btn) {
      var url = getProductUrl(btn);
      if (url) {
        window.location.href = url;
      }
    }

    function buildFlavorItem(btn) {
      if (btn.closest('.bendu-kit__flavor-item')) return;

      var parent = btn.parentNode;
      var item = document.createElement('div');
      item.className = 'bendu-kit__flavor-item';

      parent.insertBefore(item, btn);
      item.appendChild(btn);

      var removeEl = btn.querySelector('[data-bendu-flavor-remove]');
      var countEl = btn.querySelector('[data-bendu-flavor-count]');

      var controls = document.createElement('div');
      controls.className = 'bendu-kit__flavor-controls';

      if (removeEl) {
        removeEl.hidden = false;
        controls.appendChild(removeEl);
      }

      if (countEl) {
        countEl.hidden = false;
        controls.appendChild(countEl);
      }

      var addEl = document.createElement('button');
      addEl.type = 'button';
      addEl.className = 'bendu-kit__flavor-add';
      addEl.setAttribute('data-bendu-flavor-add', '');
      addEl.setAttribute('aria-label', 'Adicionar 1 unidade');
      addEl.setAttribute('title', 'Adicionar 1 unidade');
      addEl.textContent = '+';

      controls.appendChild(addEl);
      item.appendChild(controls);

      var viewEl = document.createElement('a');
      viewEl.className = 'bendu-kit__flavor-view';
      viewEl.setAttribute('data-bendu-flavor-view', '');
      viewEl.textContent = 'Ver produto';

      var productUrl = getProductUrl(btn);

      if (productUrl) {
        viewEl.href = productUrl;
      } else {
        viewEl.href = '#';
      }

      if (btn.classList.contains('is-unavailable') || btn.disabled) {
        viewEl.classList.add('is-disabled');
        viewEl.setAttribute('aria-disabled', 'true');
        viewEl.removeAttribute('href');
      }

      item.appendChild(viewEl);
    }

    function onFlavorClick(btn) {
      if (
        btn.classList.contains('is-unavailable') ||
        btn.disabled
      ) {
        return;
      }

      if (tryAdd(btn)) {
        render();
      }
    }

    function render() {
      var total = totalSelected();
      var minRequired = state.mode === 1 ? 1 : kitQuantity;

      if (counterEl) {
        if (state.mode === 1) {
          counterEl.textContent =
            total +
            '/' +
            singleMax +
            (total === 1 ? ' selecionado' : ' selecionados');
        } else if (total < kitQuantity) {
          counterEl.textContent =
            total + '/' + kitQuantity + ' selecionados';
        } else {
          counterEl.textContent =
            total + ' selecionados';
        }
      }

      if (state.mode === kitQuantity && perUnitPriceEl) {
        var perUnit = Math.round(basePrice * discountFactor);
        perUnitPriceEl.textContent = formatBRL(perUnit);
      }

      flavorButtons.forEach(function (btn) {
        var variantId = btn.dataset.variantId;
        var sel = state.selections[variantId];
        var qty = sel ? sel.qty : 0;

        var item = btn.closest('.bendu-kit__flavor-item');
        var countEl = item
          ? item.querySelector('[data-bendu-flavor-count]')
          : null;
        var removeEl = item
          ? item.querySelector('[data-bendu-flavor-remove]')
          : null;
        var addEl = item
          ? item.querySelector('[data-bendu-flavor-add]')
          : null;

        btn.classList.toggle('is-selected', qty > 0);

        if (countEl) {
          countEl.hidden = false;
          countEl.textContent = qty;
        }

        if (removeEl) {
          removeEl.hidden = false;
          removeEl.classList.toggle('is-disabled', qty <= 0);
          removeEl.setAttribute(
            'aria-disabled',
            qty <= 0 ? 'true' : 'false'
          );
        }

        if (addEl) {
          var addDisabled =
            btn.classList.contains('is-unavailable') ||
            btn.disabled ||
            !canAddByStock(btn);

          addEl.classList.toggle('is-disabled', addDisabled);
          addEl.disabled = addDisabled;
        }
      });

      if (ctaBtn && ctaText) {
        if (total >= minRequired) {
          ctaBtn.disabled = false;
          ctaText.textContent = 'Comprar Agora';
        } else {
          ctaBtn.disabled = true;

          var remaining = minRequired - total;

          ctaText.textContent =
            'Selecione ' +
            remaining +
            (remaining === 1 ? ' sabor' : ' sabores');
        }
      }

      updateExternalPrice();
    }

    function updateExternalPrice() {
      if (!basePrice) return;

      var total = totalSelected();
      var units;
      var displayPrice;

      if (state.mode === 1) {
        units = total > 0 ? total : 1;
        displayPrice = basePrice * units;
      } else {
        units = Math.max(kitQuantity, total);
        displayPrice = Math.round(
          basePrice * units * discountFactor
        );
      }

      var installment = displayPrice / 3;
      var cashback = displayPrice * 0.1;

      var priceEls = scope.querySelectorAll(
        '.wt-product__price__final, .price__container .price-item--regular'
      );

      priceEls.forEach(function (el) {
        if (
          el.classList.contains(
            'wt-product__price__compare'
          )
        ) {
          return;
        }

        el.textContent = formatBRL(displayPrice);
      });

      var displayCompare = baseCompare * units;

      if (displayCompare > displayPrice) {
        scope
          .querySelectorAll('.wt-product__price__compare')
          .forEach(function (el) {
            el.textContent = formatBRL(displayCompare);
          });

        var pct = Math.floor(
          ((displayCompare - displayPrice) * 100) /
            displayCompare
        );

        scope
          .querySelectorAll('.price-item--percent')
          .forEach(function (el) {
            el.textContent = pct + '% OFF';
          });
      }

      var installEl = scope.querySelector(
        '.bendu-payment-info__installment strong'
      );

      if (installEl) {
        installEl.textContent = formatBRL(installment);
      }

      var cashbackEl = scope.querySelector(
        '.bendu-payment-info__cashback strong'
      );

      if (cashbackEl) {
        cashbackEl.textContent = formatBRL(cashback);
      }
    }

    function addToCart() {
      if (!ctaBtn || ctaBtn.disabled) return;

      ctaBtn.classList.add('is-loading');

      var items = [];

      for (var k in state.selections) {
        items.push({
          id: parseInt(k, 10),
          quantity: state.selections[k].qty,
        });
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsParam = '';

      if (
        cartDrawer &&
        typeof cartDrawer.getSectionsToRender ===
          'function'
      ) {
        sectionsParam = cartDrawer
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(',');
      }

      var body = {
        items: items,
        sections: sectionsParam,
        sections_url: window.location.pathname,
      };

      fetch(
        window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        }
      )
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          if (
            response.status &&
            response.status !== 200
          ) {
            console.error(
              '[bendu-kit] add error',
              response
            );

            alert(
              response.description ||
                response.message ||
                'Erro ao adicionar ao carrinho.'
            );

            return;
          }

          if (
            typeof window.publish === 'function' &&
            window.PUB_SUB_EVENTS
          ) {
            window.publish(
              window.PUB_SUB_EVENTS.cartUpdate,
              {
                source: 'bendu-kit-selector',
                cartData: response,
              }
            );
          }

          var quickBuyCloseBtn =
            document.querySelector(
              '.wt__quick-buy .close-btn'
            );

          if (quickBuyCloseBtn) {
            quickBuyCloseBtn.click();
          }

          if (
            cartDrawer &&
            typeof cartDrawer.renderContents ===
              'function'
          ) {
            cartDrawer.renderContents(response, true);
          } else {
            window.location.href =
              (window.routes &&
                window.routes.cart_url) ||
              '/cart';
          }
        })
        .catch(function (err) {
          console.error(
            '[bendu-kit] fetch error',
            err
          );

          alert(
            'Erro ao adicionar ao carrinho. Tente novamente.'
          );
        })
        .finally(function () {
          ctaBtn.classList.remove('is-loading');
        });
    }

    /* Monta a estrutura externa antes de ligar os eventos */
    flavorButtons.forEach(function (btn) {
      buildFlavorItem(btn);
    });

    qtyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = parseInt(
          btn.dataset.benduQty,
          10
        );

        if (mode !== state.mode) {
          setQtyMode(mode);
        }
      });
    });

    flavorButtons.forEach(function (btn) {
      /* Clicar no card seleciona/adiciona 1 */
      btn.addEventListener('click', function () {
        onFlavorClick(btn);
      });

      var item = btn.closest('.bendu-kit__flavor-item');
      if (!item) return;

      var removeEl = item.querySelector(
        '[data-bendu-flavor-remove]'
      );
      var addEl = item.querySelector(
        '[data-bendu-flavor-add]'
      );
      var viewEl = item.querySelector(
        '[data-bendu-flavor-view]'
      );

      if (removeEl) {
        removeEl.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();

            var variantId =
              btn.dataset.variantId;

            if (!state.selections[variantId]) {
              return;
            }

            removeOne(variantId);

            if (
              state.mode === kitQuantity &&
              totalSelected() <= singleMax
            ) {
              setQtyMode(1);
            } else {
              render();
            }
          }
        );
      }

      if (addEl) {
        addEl.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (tryAdd(btn)) {
              render();
            }
          }
        );
      }

      if (viewEl) {
        viewEl.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            openFlavorProduct(btn);
          }
        );
      }
    });

    if (ctaBtn) {
      ctaBtn.addEventListener(
        'click',
        addToCart
      );
    }

    var currentHandle =
      root.dataset.currentHandle || '';
    var preBtn = null;

    if (currentHandle) {
      flavorButtons.forEach(function (btn) {
        if (
          !preBtn &&
          btn.dataset.flavorHandle ===
            currentHandle &&
          !btn.classList.contains(
            'is-unavailable'
          ) &&
          !btn.disabled
        ) {
          preBtn = btn;
        }
      });
    }

    if (!preBtn) {
      var badgeEl = root.querySelector(
        '.bendu-kit__flavor-badge--escolhido'
      );

      if (badgeEl) {
        var badgeBtn = badgeEl.closest(
          '[data-bendu-flavor]'
        );

        if (
          badgeBtn &&
          !badgeBtn.classList.contains(
            'is-unavailable'
          )
        ) {
          preBtn = badgeBtn;
        }
      }
    }

    if (!preBtn) {
      flavorButtons.forEach(function (btn) {
        if (
          !preBtn &&
          !btn.classList.contains(
            'is-unavailable'
          ) &&
          !btn.disabled
        ) {
          preBtn = btn;
        }
      });
    }

    if (preBtn) {
      addOne(
        preBtn.dataset.variantId,
        getFlavorData(preBtn)
      );
    }

    setQtyMode(1);
  }

  function init() {
    document
      .querySelectorAll('[data-bendu-kit]')
      .forEach(initKit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  function subscribeWhenReady() {
    if (
      typeof window.subscribe === 'function'
    ) {
      window.subscribe(
        'quick-buy-drawer-open',
        function () {
          setTimeout(init, 0);
        }
      );

      return true;
    }

    return false;
  }

  if (!subscribeWhenReady()) {
    document.addEventListener(
      'DOMContentLoaded',
      subscribeWhenReady
    );
  }
})();
